import React from 'react';
const label=s=>String(s).replace(/_/g,' ');
const text=v=>v==null?'Not recorded':String(v);
function conditions(node){
 if(!node)return 'No additional filters';
 if(node.all||node.any){const key=node.all?'all':'any',children=node[key];return children.length?'('+children.map(conditions).join(key==='all'?' AND ':' OR ')+')':'No additional filters';}
 const v=node.value;
 if(node.op==='period')return `${label(node.field)}: ${v.start} through ${v.end} (India dates)`;
 return `${label(node.field)} ${label(node.op)}${v===undefined?'':` ${Array.isArray(v)?v.join(', '):text(v)}`}`;
}
export default function GeneralQueryView({result:r,disabled,onRun}){
 const p=r.applied_query||r.plan;
 if(!p||r.kind==='query_review')return null;
 return <div className="space-y-2">
  {!r.rows.length?<p>No matching records.</p>:<div className="overflow-x-auto"><table className="w-full text-left"><thead><tr>{r.columns.map(c=><th className="p-2" key={c}>{label(c)}</th>)}</tr></thead><tbody>{r.rows.map((row,i)=><tr key={i}>{r.columns.map(c=><td className="border-t p-2 break-words whitespace-pre-wrap" key={c}>{text(row[c])}</td>)}</tr>)}</tbody></table></div>}
  {r.has_more&&<button type="button" disabled={disabled} className="rounded border px-3 py-2" onClick={()=>onRun({...p,offset:r.next_offset})}>Next 25 records</button>}
  <details className="text-sm"><summary className="cursor-pointer">Answer details</summary>
   <p>Dataset: {label(p.table)} · {label(p.action)}</p>
   <p className="whitespace-pre-wrap break-words">Filters: {conditions(p.where)}</p>
   {!!p.columns?.length&&<p>Fields: {p.columns.map(label).join(', ')}</p>}
   {!!p.group_by?.length&&<p>Group by: {p.group_by.map(label).join(', ')}</p>}
   {p.min_group_count&&<p>Only batch groups with at least {p.min_group_count} infection report records.</p>}
   {p.aggregate&&<p>Calculation: {label(p.aggregate.function)} of {label(p.aggregate.field)}</p>}
   {!!p.sort?.length&&<p>Order: {p.sort.map(s=>`${label(s.field)} ${s.direction}`).join(', ')}</p>}
   {r.record_basis&&<p>{r.record_basis}</p>}
  </details>
 </div>;
}
